import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../../base/Grid';
import Typography from '../../../base/Typography';
import Button from '../../../base/Button';
import jsRedirect from '../../../../helpers/jsRedirect';

import {
  PhotoCol,
  TypographyHeadlineStyled,
  DivButtonContainer,
  PictureFRPhotoStyled,
} from './styles';

const DefaultCard = ({
  backgroundVariant,
  desktopWebpSrc,
  headline,
  imageSrc,
  mobileImageSrc,
  mobileWebpSrc,
  cta,
  text,
  subText,
}) => {
  const contents = <Fragment>
    <TypographyHeadlineStyled component='h2'>
      {headline}
    </TypographyHeadlineStyled>
    {/* TODO: ensure defaultText can handle html being passed in or maybe a react component? */}
    <Typography component='p'>
      {text}
    </Typography>
    {subText && (
      <Typography component='p' weight={400}>
        {subText}
      </Typography>
    )}
    {cta
      && (
        <DivButtonContainer>
          <Button
            id="advisor-card-connect-button"
            variant={backgroundVariant === 'quarternary' ? 'secondary' : backgroundVariant}
            style={{ minWidth: '8rem' }}
            onClick={() => jsRedirect(cta.link)}>
            {cta.text}
          </Button>
        </DivButtonContainer>
      )}
  </Fragment>;

  return imageSrc ? (
    <Row align="center">
      <PhotoCol xsmall={12} medium={3}>
        <PictureFRPhotoStyled
          src={imageSrc}
          mobileSrc={mobileImageSrc}
          mobileWebpSrc={mobileWebpSrc}
          desktopWebpSrc={desktopWebpSrc}
          alt={'Picture of a financial representative'}
          width="200"
          height="100%"
        />
      </PhotoCol>
      <Col xsmall={12} medium={7}>
        {contents}
      </Col>
    </Row>
  ) : (
    <Row styles={{ textAlign: 'center' }}>
      <Col xsmall={12} small={10} medium={8}>
        {contents}
      </Col>
    </Row>
  );
};

DefaultCard.propTypes = {
  backgroundVariant: PropTypes.string,
  desktopWebpSrc: PropTypes.string,
  headline: PropTypes.string,
  imageOnTop: PropTypes.bool,
  imageSrc: PropTypes.string,
  mobileImageSrc: PropTypes.string,
  mobileWebpSrc: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
  text: PropTypes.string,
};

DefaultCard.defaultProps = {
  desktopWebpSrc: '/assets/images/frs/leo-tucker-desktop-v7.webp',
  headline: 'Take the next step.',
  imageSrc: '/assets/images/frs/leo-tucker-desktop-v7.jpg',
  mobileImageSrc: '/assets/images/frs/leo-tucker-mobile-v6.jpg',
  mobileWebpSrc: '/assets/images/frs/leo-tucker-mobile-v6.webp',
  text: 'Our advisors are here to give you more of the information you want, and the knowledge you never knew you needed. To get to your next goal, and the next.',
};

export default DefaultCard;
